import React, { useState } from 'react';
import { ChromePicker } from 'react-color';

import ShowInsideScreen from '../../../ShowInsideScreen/ShowInsideScreen';

import styles from './ColorPicker.module.css';

export default ({ colorCode, onChange, style }) => {
  const [pickerVisible, setPickerVisible] = useState(false);
  const [pickerContainerRef, setPickerContainerRef] = useState(null);

  const [internalValue, setInternalValue] = useState(colorCode);

  return (
    <div
      className={styles.container}
      role="presentation"
      onClick={() => setPickerVisible(true)}
      style={style || {}}
    >
      <div
        className={styles.colorRectangle}
        style={{ backgroundColor: colorCode }}
      />
      <div className={styles.colorCode}>{colorCode}</div>
      {pickerVisible && [
        <ShowInsideScreen
          key="show-inside-screen-picker"
          positionStyle={{
            top: '33px',
            left: '10px',
            bottomPosition: '33px'
          }}
          childReference={pickerContainerRef}
          onBlur={() => {
            setPickerVisible(false);
            onChange(internalValue.hex || internalValue);
          }}
        >
          <div
            className={styles.pickerContainer}
            ref={r => setPickerContainerRef(r)}
          >
            <ChromePicker
              disableAlpha
              color={internalValue}
              onChangeComplete={color => {
                setInternalValue(color);
              }}
            />
          </div>
        </ShowInsideScreen>,
        <div
          key="show-inside-screen-cover"
          className={styles.transparentPageConver}
        />
      ]}
    </div>
  );
};
